import axios from "../axios-interceptor.js";

const BACKEND_API = process.env.REACT_APP_BACKEND_API;

/**
 * Fetch company plan details including features/limits
 * @param {string} companyName - Company name/identifier
 * @returns {Promise<{success: boolean, data: object, message: string}>}
 */
export const fetchCompanyPlan = async (companyName) => {
    let responseObj = { success: false, data: null, message: "" };

    try {
        const res = await axios({
            method: "GET",
            url: `${BACKEND_API}/company`,
            params: {
                companyName: companyName
            }
        });

        if (res.status === 200 && res.data?.result) {
            responseObj.success = true;
            responseObj.data = res.data.result;
            responseObj.message = res.data?.message || "Company plan fetched successfully";
        } else {
            responseObj.message = res.data?.message || "Failed to fetch company plan";
        }
    } catch (error) {
        responseObj.message = error.response?.data?.message || "Unable to fetch company plan. Please try again.";
    }

    return responseObj;
};

const planServices = {
    fetchCompanyPlan
};

export default planServices;
